import { Link, useLocation } from "react-router";
import css from "./Nav.module.css";

export function Nav(params: { character: { id: number; }; }) {
  const { character } = params;
  const { pathname } = useLocation();
  const currentPathname = getCurrentPath(pathname);

  return (
    <div className={css.root}>
      {DEV && <div>
        <Link
          to={`/tracker/${character.id}/character`}
          className={
            currentPathname === "character" ? css.activeItem : css.item
          }
        >
          Character
        </Link>

      </div>
      }
      <div>
        <Link
          to={`/tracker/${character.id}/stats?period=today`}
          className={currentPathname === "stats" ? css.activeItem : css.item}
        >
          Stats
        </Link>
      </div>
    </div>
  );
}

function getCurrentPath(pathname: string) {
  const n = pathname.lastIndexOf("/");
  return pathname.substring(n + 1);
}
